export const REGION_TILES_DATA = [
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 66,
    mittl_preis_qm_miete_neubau: 18.5722727776,
    _angebote_miete_bestand: 263,
    mittl_preis_qm_miete_bestand: 12.7067680377,
    _angebote_kauf_neubau: 34,
    mittl_preis_qm_kauf_neubau: 7614.4161592371,
    _angebote_kauf_bestand: 693,
    mittl_preis_qm_kauf_bestand: 4916.8942473,
    zeit: '2023-Q3',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    _angebote_miete_neubau: 128,
    mittl_preis_qm_miete_neubau: 26.0950781405,
    _angebote_miete_bestand: 488,
    mittl_preis_qm_miete_bestand: 19.2379713137,
    _angebote_kauf_neubau: 237,
    mittl_preis_qm_kauf_neubau: 11312.2614200125,
    _angebote_kauf_bestand: 1969,
    mittl_preis_qm_kauf_bestand: 6420.459491875,
    zeit: '2023-Q3',
  },
  {
    name: 'Treptow-Köpenick',
    _angebote_miete_neubau: 278,
    mittl_preis_qm_miete_neubau: 20.2234171998,
    _angebote_miete_bestand: 460,
    mittl_preis_qm_miete_bestand: 13.8333695598,
    _angebote_kauf_neubau: 144,
    mittl_preis_qm_kauf_neubau: 7252.0258144803,
    _angebote_kauf_bestand: 597,
    mittl_preis_qm_kauf_bestand: 4397.4205365205,
    zeit: '2023-Q3',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 36,
    mittl_preis_qm_miete_neubau: 19.0491665999,
    _angebote_miete_bestand: 226,
    mittl_preis_qm_miete_bestand: 11.9107522184,
    _angebote_kauf_neubau: 70,
    mittl_preis_qm_kauf_neubau: 7400.3811383929,
    _angebote_kauf_bestand: 513,
    mittl_preis_qm_kauf_bestand: 4061.1820860746,
    zeit: '2023-Q3',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 171,
    mittl_preis_qm_miete_neubau: 27.6576607576,
    _angebote_miete_bestand: 534,
    mittl_preis_qm_miete_bestand: 19.5846067448,
    _angebote_kauf_neubau: 145,
    mittl_preis_qm_kauf_neubau: 9549.322501347,
    _angebote_kauf_bestand: 1326,
    mittl_preis_qm_kauf_bestand: 6523.1790815673,
    zeit: '2023-Q3',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 84,
    mittl_preis_qm_miete_neubau: 18.2728571778,
    _angebote_miete_bestand: 261,
    mittl_preis_qm_miete_bestand: 10.6321839154,
    _angebote_kauf_neubau: 46,
    mittl_preis_qm_kauf_neubau: 6768.3162894871,
    _angebote_kauf_bestand: 365,
    mittl_preis_qm_kauf_bestand: 3820.0342171447,
    zeit: '2023-Q3',
  },
  {
    name: 'Marzahn-Hellersdorf',
    _angebote_miete_neubau: 55,
    mittl_preis_qm_miete_neubau: 15.3621818022,
    _angebote_miete_bestand: 227,
    mittl_preis_qm_miete_bestand: 9.3921145343,
    _angebote_kauf_neubau: 49,
    mittl_preis_qm_kauf_neubau: 5311.0250617825,
    _angebote_kauf_bestand: 99,
    mittl_preis_qm_kauf_bestand: 3808.1809008049,
    zeit: '2023-Q3',
  },
  {
    name: 'Steglitz-Zehlendorf',
    _angebote_miete_neubau: 43,
    mittl_preis_qm_miete_neubau: 19.761395277,
    _angebote_miete_bestand: 370,
    mittl_preis_qm_miete_bestand: 14.944000007,
    _angebote_kauf_neubau: 73,
    mittl_preis_qm_kauf_neubau: 8562.4095810146,
    _angebote_kauf_bestand: 1172,
    mittl_preis_qm_kauf_bestand: 5124.5571276564,
    zeit: '2023-Q3',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 147,
    mittl_preis_qm_miete_neubau: 19.3477551272,
    _angebote_miete_bestand: 184,
    mittl_preis_qm_miete_bestand: 13.4126630581,
    _angebote_kauf_neubau: 74,
    mittl_preis_qm_kauf_neubau: 7175.2100269215,
    _angebote_kauf_bestand: 283,
    mittl_preis_qm_kauf_bestand: 4309.0464281278,
    zeit: '2023-Q3',
  },
  {
    name: 'Tempelhof-Schöneberg',
    _angebote_miete_neubau: 47,
    mittl_preis_qm_miete_neubau: 22.7542552542,
    _angebote_miete_bestand: 287,
    mittl_preis_qm_miete_bestand: 14.5439372428,
    _angebote_kauf_neubau: 119,
    mittl_preis_qm_kauf_neubau: 8428.7392331933,
    _angebote_kauf_bestand: 1042,
    mittl_preis_qm_kauf_bestand: 5188.9532740148,
    zeit: '2023-Q3',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    _angebote_miete_neubau: 110,
    mittl_preis_qm_miete_neubau: 28.5487271742,
    _angebote_miete_bestand: 275,
    mittl_preis_qm_miete_bestand: 20.0379636834,
    _angebote_kauf_neubau: 266,
    mittl_preis_qm_kauf_neubau: 9717.7548626204,
    _angebote_kauf_bestand: 1099,
    mittl_preis_qm_kauf_bestand: 6203.3931910313,
    zeit: '2023-Q3',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 117,
    mittl_preis_qm_miete_neubau: 22.6140171035,
    _angebote_miete_bestand: 451,
    mittl_preis_qm_miete_bestand: 16.4887582902,
    _angebote_kauf_neubau: 276,
    mittl_preis_qm_kauf_neubau: 7681.0064714957,
    _angebote_kauf_bestand: 1249,
    mittl_preis_qm_kauf_bestand: 5808.7018902231,
    zeit: '2023-Q3',
  },
  {
    name: 'Friedrichshain',
    _angebote_miete_neubau: 80,
    mittl_preis_qm_miete_neubau: 30.0198749304,
    _angebote_miete_bestand: 171,
    mittl_preis_qm_miete_bestand: 20.1027486199,
    _angebote_kauf_neubau: 210,
    mittl_preis_qm_kauf_neubau: 9613.3444149926,
    _angebote_kauf_bestand: 755,
    mittl_preis_qm_kauf_bestand: 5988.0094461403,
    zeit: '2023-Q3',
  },
  {
    name: 'Tempelhof',
    _angebote_miete_neubau: 3,
    mittl_preis_qm_miete_neubau: 23.5,
    _angebote_miete_bestand: 29,
    mittl_preis_qm_miete_bestand: 15.6155172052,
    _angebote_kauf_neubau: 4,
    mittl_preis_qm_kauf_neubau: 5673.232421875,
    _angebote_kauf_bestand: 141,
    mittl_preis_qm_kauf_bestand: 4474.5443920379,
    zeit: '2023-Q3',
  },
  {
    name: 'Wedding',
    _angebote_miete_neubau: 12,
    mittl_preis_qm_miete_neubau: 23.6983332634,
    _angebote_miete_bestand: 69,
    mittl_preis_qm_miete_bestand: 13.3924637255,
    _angebote_kauf_neubau: 8,
    mittl_preis_qm_kauf_neubau: 7591.0888061523,
    _angebote_kauf_bestand: 224,
    mittl_preis_qm_kauf_bestand: 4414.6183035714,
    zeit: '2023-Q3',
  },
  {
    name: 'Kreuzberg',
    _angebote_miete_neubau: 30,
    mittl_preis_qm_miete_neubau: 25.1493331909,
    _angebote_miete_bestand: 102,
    mittl_preis_qm_miete_bestand: 19.8681372381,
    _angebote_kauf_neubau: 56,
    mittl_preis_qm_kauf_neubau: 10156.301940918,
    _angebote_kauf_bestand: 344,
    mittl_preis_qm_kauf_bestand: 6698.7082136287,
    zeit: '2023-Q3',
  },
  {
    name: 'Charlottenburg',
    _angebote_miete_neubau: 60,
    mittl_preis_qm_miete_neubau: 25.5411667506,
    _angebote_miete_bestand: 189,
    mittl_preis_qm_miete_bestand: 20.1083068747,
    _angebote_kauf_neubau: 78,
    mittl_preis_qm_kauf_neubau: 9715.6535456731,
    _angebote_kauf_bestand: 848,
    mittl_preis_qm_kauf_bestand: 6544.1324972477,
    zeit: '2023-Q3',
  },
  {
    name: 'Köpenick',
    _angebote_miete_neubau: 109,
    mittl_preis_qm_miete_neubau: 18.5833027253,
    _angebote_miete_bestand: 164,
    mittl_preis_qm_miete_bestand: 11.155670733,
    _angebote_kauf_neubau: 81,
    mittl_preis_qm_kauf_neubau: 7726.6661542728,
    _angebote_kauf_bestand: 205,
    mittl_preis_qm_kauf_bestand: 4585.8664324505,
    zeit: '2023-Q3',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 43,
    mittl_preis_qm_miete_neubau: 20.7734885105,
    _angebote_miete_bestand: 139,
    mittl_preis_qm_miete_bestand: 15.6726618671,
    _angebote_kauf_neubau: 26,
    mittl_preis_qm_kauf_neubau: 7892.0784442608,
    _angebote_kauf_bestand: 444,
    mittl_preis_qm_kauf_bestand: 5429.8031093838,
    zeit: '2023-Q3',
  },
  {
    name: 'Steglitz',
    _angebote_miete_neubau: 2,
    mittl_preis_qm_miete_neubau: 26.7950000763,
    _angebote_miete_bestand: 70,
    mittl_preis_qm_miete_bestand: 15.5538572039,
    _angebote_kauf_neubau: 21,
    mittl_preis_qm_kauf_neubau: 8169.9571475074,
    _angebote_kauf_bestand: 405,
    mittl_preis_qm_kauf_bestand: 5071.2460250289,
    zeit: '2023-Q3',
  },
  {
    name: 'Schöneberg',
    _angebote_miete_neubau: 18,
    mittl_preis_qm_miete_neubau: 24.6577775743,
    _angebote_miete_bestand: 88,
    mittl_preis_qm_miete_bestand: 18.2203408155,
    _angebote_kauf_neubau: 36,
    mittl_preis_qm_kauf_neubau: 11567.3121880425,
    _angebote_kauf_bestand: 395,
    mittl_preis_qm_kauf_bestand: 5757.6093224634,
    zeit: '2023-Q3',
  },
  {
    name: 'Wilmersdorf',
    _angebote_miete_neubau: 43,
    mittl_preis_qm_miete_neubau: 27.5202324446,
    _angebote_miete_bestand: 126,
    mittl_preis_qm_miete_bestand: 20.077222211,
    _angebote_kauf_neubau: 134,
    mittl_preis_qm_kauf_neubau: 13252.6978231402,
    _angebote_kauf_bestand: 613,
    mittl_preis_qm_kauf_bestand: 6343.6046041019,
    zeit: '2023-Q3',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 75,
    mittl_preis_qm_miete_neubau: 28.511866684,
    _angebote_miete_bestand: 241,
    mittl_preis_qm_miete_bestand: 22.7908299118,
    _angebote_kauf_neubau: 56,
    mittl_preis_qm_kauf_neubau: 10703.2544555664,
    _angebote_kauf_bestand: 539,
    mittl_preis_qm_kauf_bestand: 8189.2774977534,
    zeit: '2023-Q3',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 16,
    mittl_preis_qm_miete_neubau: 19.8156250715,
    _angebote_miete_bestand: 66,
    mittl_preis_qm_miete_bestand: 12.3115151145,
    _angebote_kauf_neubau: 51,
    mittl_preis_qm_kauf_neubau: 7009.4487783395,
    _angebote_kauf_bestand: 311,
    mittl_preis_qm_kauf_bestand: 3949.6949192059,
    zeit: '2023-Q3',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 33,
    mittl_preis_qm_miete_neubau: 23.2845453783,
    _angebote_miete_bestand: 47,
    mittl_preis_qm_miete_bestand: 16.6125531704,
    _angebote_kauf_neubau: 36,
    mittl_preis_qm_kauf_neubau: 7759.3463541667,
    _angebote_kauf_bestand: 200,
    mittl_preis_qm_kauf_bestand: 5384.0944360352,
    zeit: '2023-Q3',
  },
  {
    name: 'Zehlendorf',
    _angebote_miete_neubau: 3,
    mittl_preis_qm_miete_neubau: 25.8900000254,
    _angebote_miete_bestand: 85,
    mittl_preis_qm_miete_bestand: 14.0516470516,
    _angebote_kauf_neubau: 19,
    mittl_preis_qm_kauf_neubau: 9952.9252672697,
    _angebote_kauf_bestand: 205,
    mittl_preis_qm_kauf_bestand: 5061.6316561071,
    zeit: '2023-Q3',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 11,
    mittl_preis_qm_miete_neubau: 26.8445453644,
    _angebote_miete_bestand: 12,
    mittl_preis_qm_miete_bestand: 14.1166668733,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 7896.0521918403,
    _angebote_kauf_bestand: 58,
    mittl_preis_qm_kauf_bestand: 4296.5496531519,
    zeit: '2023-Q3',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 14,
    mittl_preis_qm_miete_neubau: 18.2057142258,
    _angebote_miete_bestand: 48,
    mittl_preis_qm_miete_bestand: 11.513958325,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 7033.6488715278,
    _angebote_kauf_bestand: 151,
    mittl_preis_qm_kauf_bestand: 3961.2586160622,
    zeit: '2023-Q3',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 40,
    mittl_preis_qm_miete_neubau: 19.5327500105,
    _angebote_miete_bestand: 210,
    mittl_preis_qm_miete_bestand: 11.5602857272,
    _angebote_kauf_neubau: 23,
    mittl_preis_qm_kauf_neubau: 7290.5774031929,
    _angebote_kauf_bestand: 590,
    mittl_preis_qm_kauf_bestand: 5018.3446003542,
    zeit: '2023-Q1',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    _angebote_miete_neubau: 120,
    mittl_preis_qm_miete_neubau: 24.9839165052,
    _angebote_miete_bestand: 433,
    mittl_preis_qm_miete_bestand: 18.2167898447,
    _angebote_kauf_neubau: 182,
    mittl_preis_qm_kauf_neubau: 11718.8995589372,
    _angebote_kauf_bestand: 1810,
    mittl_preis_qm_kauf_bestand: 6472.419813428,
    zeit: '2023-Q1',
  },
  {
    name: 'Treptow-Köpenick',
    _angebote_miete_neubau: 312,
    mittl_preis_qm_miete_neubau: 17.3729807719,
    _angebote_miete_bestand: 443,
    mittl_preis_qm_miete_bestand: 13.3160496544,
    _angebote_kauf_neubau: 135,
    mittl_preis_qm_kauf_neubau: 7240.1075484664,
    _angebote_kauf_bestand: 621,
    mittl_preis_qm_kauf_bestand: 4475.1194087472,
    zeit: '2023-Q1',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 27,
    mittl_preis_qm_miete_neubau: 18.6674072478,
    _angebote_miete_bestand: 219,
    mittl_preis_qm_miete_bestand: 11.1059817353,
    _angebote_kauf_neubau: 64,
    mittl_preis_qm_kauf_neubau: 7656.5706558228,
    _angebote_kauf_bestand: 424,
    mittl_preis_qm_kauf_bestand: 4298.1282711389,
    zeit: '2023-Q1',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 129,
    mittl_preis_qm_miete_neubau: 27.9908526812,
    _angebote_miete_bestand: 515,
    mittl_preis_qm_miete_bestand: 18.39796116,
    _angebote_kauf_neubau: 170,
    mittl_preis_qm_kauf_neubau: 9317.2407513787,
    _angebote_kauf_bestand: 1294,
    mittl_preis_qm_kauf_bestand: 6524.1097393242,
    zeit: '2023-Q1',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 79,
    mittl_preis_qm_miete_neubau: 16.8888606904,
    _angebote_miete_bestand: 265,
    mittl_preis_qm_miete_bestand: 9.6298490578,
    _angebote_kauf_neubau: 45,
    mittl_preis_qm_kauf_neubau: 7142.3319878472,
    _angebote_kauf_bestand: 344,
    mittl_preis_qm_kauf_bestand: 4007.3595850745,
    zeit: '2023-Q1',
  },
  {
    name: 'Marzahn-Hellersdorf',
    _angebote_miete_neubau: 68,
    mittl_preis_qm_miete_neubau: 12.5651469511,
    _angebote_miete_bestand: 299,
    mittl_preis_qm_miete_bestand: 8.9795317889,
    _angebote_kauf_neubau: 51,
    mittl_preis_qm_kauf_neubau: 5239.0248831955,
    _angebote_kauf_bestand: 78,
    mittl_preis_qm_kauf_bestand: 3939.2461688702,
    zeit: '2023-Q1',
  },
  {
    name: 'Steglitz-Zehlendorf',
    _angebote_miete_neubau: 38,
    mittl_preis_qm_miete_neubau: 24.6413159119,
    _angebote_miete_bestand: 332,
    mittl_preis_qm_miete_bestand: 14.1456325227,
    _angebote_kauf_neubau: 45,
    mittl_preis_qm_kauf_neubau: 8574.0322048611,
    _angebote_kauf_bestand: 1075,
    mittl_preis_qm_kauf_bestand: 5390.1283925327,
    zeit: '2023-Q1',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 130,
    mittl_preis_qm_miete_neubau: 18.7365383882,
    _angebote_miete_bestand: 199,
    mittl_preis_qm_miete_bestand: 12.3227135884,
    _angebote_kauf_neubau: 100,
    mittl_preis_qm_kauf_neubau: 7456.5813964844,
    _angebote_kauf_bestand: 257,
    mittl_preis_qm_kauf_bestand: 4472.2451808351,
    zeit: '2023-Q1',
  },
  {
    name: 'Tempelhof-Schöneberg',
    _angebote_miete_neubau: 33,
    mittl_preis_qm_miete_neubau: 21.909090938,
    _angebote_miete_bestand: 335,
    mittl_preis_qm_miete_bestand: 13.2778208989,
    _angebote_kauf_neubau: 90,
    mittl_preis_qm_kauf_neubau: 8036.0956597222,
    _angebote_kauf_bestand: 944,
    mittl_preis_qm_kauf_bestand: 5220.6848739365,
    zeit: '2023-Q1',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    _angebote_miete_neubau: 61,
    mittl_preis_qm_miete_neubau: 26.6221310975,
    _angebote_miete_bestand: 227,
    mittl_preis_qm_miete_bestand: 18.634581528,
    _angebote_kauf_neubau: 177,
    mittl_preis_qm_kauf_neubau: 9902.4541125971,
    _angebote_kauf_bestand: 1080,
    mittl_preis_qm_kauf_bestand: 6223.6423602069,
    zeit: '2023-Q1',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 124,
    mittl_preis_qm_miete_neubau: 21.4272580531,
    _angebote_miete_bestand: 443,
    mittl_preis_qm_miete_bestand: 14.7790519152,
    _angebote_kauf_neubau: 386,
    mittl_preis_qm_kauf_neubau: 8001.8249347272,
    _angebote_kauf_bestand: 1199,
    mittl_preis_qm_kauf_bestand: 5812.1712480534,
    zeit: '2023-Q1',
  },
  {
    name: 'Friedrichshain',
    _angebote_miete_neubau: 38,
    mittl_preis_qm_miete_neubau: 27.1810525091,
    _angebote_miete_bestand: 147,
    mittl_preis_qm_miete_bestand: 18.6838095658,
    _angebote_kauf_neubau: 148,
    mittl_preis_qm_kauf_neubau: 9861.4830322266,
    _angebote_kauf_bestand: 740,
    mittl_preis_qm_kauf_bestand: 5984.5596333272,
    zeit: '2023-Q1',
  },
  {
    name: 'Tempelhof',
    _angebote_miete_neubau: null,
    mittl_preis_qm_miete_neubau: null,
    _angebote_miete_bestand: 52,
    mittl_preis_qm_miete_bestand: 14.1199999589,
    _angebote_kauf_neubau: null,
    mittl_preis_qm_kauf_neubau: null,
    _angebote_kauf_bestand: 138,
    mittl_preis_qm_kauf_bestand: 4572.8947240857,
    zeit: '2023-Q1',
  },
  {
    name: 'Wedding',
    _angebote_miete_neubau: 9,
    mittl_preis_qm_miete_neubau: 21.1033335792,
    _angebote_miete_bestand: 79,
    mittl_preis_qm_miete_bestand: 11.9299999913,
    _angebote_kauf_neubau: 8,
    mittl_preis_qm_kauf_neubau: 8182.84375,
    _angebote_kauf_bestand: 226,
    mittl_preis_qm_kauf_bestand: 4422.5401449288,
    zeit: '2023-Q1',
  },
  {
    name: 'Kreuzberg',
    _angebote_miete_neubau: 19,
    mittl_preis_qm_miete_neubau: 27.8557895861,
    _angebote_miete_bestand: 81,
    mittl_preis_qm_miete_bestand: 18.428518519,
    _angebote_kauf_neubau: 26,
    mittl_preis_qm_kauf_neubau: 9643.4930138221,
    _angebote_kauf_bestand: 341,
    mittl_preis_qm_kauf_bestand: 6742.0025803015,
    zeit: '2023-Q1',
  },
  {
    name: 'Charlottenburg',
    _angebote_miete_neubau: 56,
    mittl_preis_qm_miete_neubau: 23.3662498338,
    _angebote_miete_bestand: 186,
    mittl_preis_qm_miete_bestand: 18.2310752766,
    _angebote_kauf_neubau: 50,
    mittl_preis_qm_kauf_neubau: 11374.0881445312,
    _angebote_kauf_bestand: 819,
    mittl_preis_qm_kauf_bestand: 6820.3808486435,
    zeit: '2023-Q1',
  },
  {
    name: 'Köpenick',
    _angebote_miete_neubau: 94,
    mittl_preis_qm_miete_neubau: 17.5231915028,
    _angebote_miete_bestand: 148,
    mittl_preis_qm_miete_bestand: 12.1163513499,
    _angebote_kauf_neubau: 46,
    mittl_preis_qm_kauf_neubau: 8655.1669497283,
    _angebote_kauf_bestand: 193,
    mittl_preis_qm_kauf_bestand: 4666.941293667,
    zeit: '2023-Q1',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 36,
    mittl_preis_qm_miete_neubau: 20.024166637,
    _angebote_miete_bestand: 82,
    mittl_preis_qm_miete_bestand: 15.5281707368,
    _angebote_kauf_neubau: 16,
    mittl_preis_qm_kauf_neubau: 7945.1956176758,
    _angebote_kauf_bestand: 366,
    mittl_preis_qm_kauf_bestand: 5549.3309079363,
    zeit: '2023-Q1',
  },
  {
    name: 'Steglitz',
    _angebote_miete_neubau: null,
    mittl_preis_qm_miete_neubau: null,
    _angebote_miete_bestand: 78,
    mittl_preis_qm_miete_bestand: 15.0248718323,
    _angebote_kauf_neubau: 22,
    mittl_preis_qm_kauf_neubau: 7835.716352983,
    _angebote_kauf_bestand: 387,
    mittl_preis_qm_kauf_bestand: 5147.2005984284,
    zeit: '2023-Q1',
  },
  {
    name: 'Schöneberg',
    _angebote_miete_neubau: 16,
    mittl_preis_qm_miete_neubau: 24.2218748927,
    _angebote_miete_bestand: 79,
    mittl_preis_qm_miete_bestand: 17.7307594999,
    _angebote_kauf_neubau: 21,
    mittl_preis_qm_kauf_neubau: 10932.6609002976,
    _angebote_kauf_bestand: 398,
    mittl_preis_qm_kauf_bestand: 5884.5501218249,
    zeit: '2023-Q1',
  },
  {
    name: 'Wilmersdorf',
    _angebote_miete_neubau: 31,
    mittl_preis_qm_miete_neubau: 28.7509673334,
    _angebote_miete_bestand: 110,
    mittl_preis_qm_miete_bestand: 20.5494545503,
    _angebote_kauf_neubau: 101,
    mittl_preis_qm_kauf_neubau: 11572.6135036355,
    _angebote_kauf_bestand: 596,
    mittl_preis_qm_kauf_bestand: 6479.0958596044,
    zeit: '2023-Q1',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 54,
    mittl_preis_qm_miete_neubau: 29.676666613,
    _angebote_miete_bestand: 219,
    mittl_preis_qm_miete_bestand: 23.1565296835,
    _angebote_kauf_neubau: 85,
    mittl_preis_qm_kauf_neubau: 9145.7366900276,
    _angebote_kauf_bestand: 488,
    mittl_preis_qm_kauf_bestand: 8508.470821193,
    zeit: '2023-Q1',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 6,
    mittl_preis_qm_miete_neubau: 16.2283334732,
    _angebote_miete_bestand: 71,
    mittl_preis_qm_miete_bestand: 10.6002817087,
    _angebote_kauf_neubau: 46,
    mittl_preis_qm_kauf_neubau: 7353.2717603601,
    _angebote_kauf_bestand: 252,
    mittl_preis_qm_kauf_bestand: 4228.4461795867,
    zeit: '2023-Q1',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 39,
    mittl_preis_qm_miete_neubau: 23.0858974457,
    _angebote_miete_bestand: 53,
    mittl_preis_qm_miete_bestand: 12.6594339587,
    _angebote_kauf_neubau: 56,
    mittl_preis_qm_kauf_neubau: 7601.6230294364,
    _angebote_kauf_bestand: 207,
    mittl_preis_qm_kauf_bestand: 5478.7160962976,
    zeit: '2023-Q1',
  },
  {
    name: 'Zehlendorf',
    _angebote_miete_neubau: 6,
    mittl_preis_qm_miete_neubau: 20.9533332189,
    _angebote_miete_bestand: 46,
    mittl_preis_qm_miete_bestand: 12.2819565794,
    _angebote_kauf_neubau: 7,
    mittl_preis_qm_kauf_neubau: 8998.2999441964,
    _angebote_kauf_bestand: 166,
    mittl_preis_qm_kauf_bestand: 5309.1512009954,
    zeit: '2023-Q1',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 18,
    mittl_preis_qm_miete_neubau: 20.6005554729,
    _angebote_miete_bestand: 21,
    mittl_preis_qm_miete_bestand: 12.6876190958,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 6831.5632595486,
    _angebote_kauf_bestand: 57,
    mittl_preis_qm_kauf_bestand: 4508.3101870888,
    zeit: '2023-Q1',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 19,
    mittl_preis_qm_miete_neubau: 17.6489473142,
    _angebote_miete_bestand: 50,
    mittl_preis_qm_miete_bestand: 10.8716000175,
    _angebote_kauf_neubau: 10,
    mittl_preis_qm_kauf_neubau: 6499.5269042969,
    _angebote_kauf_bestand: 162,
    mittl_preis_qm_kauf_bestand: 4042.0463475357,
    zeit: '2023-Q1',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 52,
    mittl_preis_qm_miete_neubau: 20.7373076586,
    _angebote_miete_bestand: 204,
    mittl_preis_qm_miete_bestand: 12.4498529551,
    _angebote_kauf_neubau: 27,
    mittl_preis_qm_kauf_neubau: 7215.291087963,
    _angebote_kauf_bestand: 645,
    mittl_preis_qm_kauf_bestand: 5032.2145833333,
    zeit: '2023-Q2',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    _angebote_miete_neubau: 122,
    mittl_preis_qm_miete_neubau: 26.1877868527,
    _angebote_miete_bestand: 423,
    mittl_preis_qm_miete_bestand: 19.3166193861,
    _angebote_kauf_neubau: 227,
    mittl_preis_qm_kauf_neubau: 11844.1492183198,
    _angebote_kauf_bestand: 1995,
    mittl_preis_qm_kauf_bestand: 6540.81372878,
    zeit: '2023-Q2',
  },
  {
    name: 'Treptow-Köpenick',
    _angebote_miete_neubau: 383,
    mittl_preis_qm_miete_neubau: 19.9085900603,
    _angebote_miete_bestand: 473,
    mittl_preis_qm_miete_bestand: 13.2709302459,
    _angebote_kauf_neubau: 157,
    mittl_preis_qm_kauf_neubau: 7134.5183400926,
    _angebote_kauf_bestand: 660,
    mittl_preis_qm_kauf_bestand: 4512.7682036429,
    zeit: '2023-Q2',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 28,
    mittl_preis_qm_miete_neubau: 19.6021428449,
    _angebote_miete_bestand: 209,
    mittl_preis_qm_miete_bestand: 11.8373206061,
    _angebote_kauf_neubau: 73,
    mittl_preis_qm_kauf_neubau: 7701.7474181293,
    _angebote_kauf_bestand: 509,
    mittl_preis_qm_kauf_bestand: 4260.4599532631,
    zeit: '2023-Q2',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 158,
    mittl_preis_qm_miete_neubau: 29.6429745879,
    _angebote_miete_bestand: 476,
    mittl_preis_qm_miete_bestand: 19.321155471,
    _angebote_kauf_neubau: 134,
    mittl_preis_qm_kauf_neubau: 9579.0042414879,
    _angebote_kauf_bestand: 1350,
    mittl_preis_qm_kauf_bestand: 6517.1504148582,
    zeit: '2023-Q2',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 60,
    mittl_preis_qm_miete_neubau: 17.9578332901,
    _angebote_miete_bestand: 277,
    mittl_preis_qm_miete_bestand: 10.3499639095,
    _angebote_kauf_neubau: 38,
    mittl_preis_qm_kauf_neubau: 6917.5889442845,
    _angebote_kauf_bestand: 367,
    mittl_preis_qm_kauf_bestand: 4057.3325607757,
    zeit: '2023-Q2',
  },
  {
    name: 'Marzahn-Hellersdorf',
    _angebote_miete_neubau: 47,
    mittl_preis_qm_miete_neubau: 14.1829786504,
    _angebote_miete_bestand: 247,
    mittl_preis_qm_miete_bestand: 9.0570445505,
    _angebote_kauf_neubau: 54,
    mittl_preis_qm_kauf_neubau: 5220.6125578704,
    _angebote_kauf_bestand: 79,
    mittl_preis_qm_kauf_bestand: 3864.6632929935,
    zeit: '2023-Q2',
  },
  {
    name: 'Steglitz-Zehlendorf',
    _angebote_miete_neubau: 51,
    mittl_preis_qm_miete_neubau: 22.1219608456,
    _angebote_miete_bestand: 329,
    mittl_preis_qm_miete_bestand: 14.3984802342,
    _angebote_kauf_neubau: 64,
    mittl_preis_qm_kauf_neubau: 8743.491394043,
    _angebote_kauf_bestand: 1186,
    mittl_preis_qm_kauf_bestand: 5342.4383738423,
    zeit: '2023-Q2',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 153,
    mittl_preis_qm_miete_neubau: 20.439542465,
    _angebote_miete_bestand: 191,
    mittl_preis_qm_miete_bestand: 12.207225148,
    _angebote_kauf_neubau: 92,
    mittl_preis_qm_kauf_neubau: 6945.3765285326,
    _angebote_kauf_bestand: 279,
    mittl_preis_qm_kauf_bestand: 4315.0286397079,
    zeit: '2023-Q2',
  },
  {
    name: 'Tempelhof-Schöneberg',
    _angebote_miete_neubau: 35,
    mittl_preis_qm_miete_neubau: 23.525428554,
    _angebote_miete_bestand: 284,
    mittl_preis_qm_miete_bestand: 14.077323932,
    _angebote_kauf_neubau: 119,
    mittl_preis_qm_kauf_neubau: 8331.3682133009,
    _angebote_kauf_bestand: 1115,
    mittl_preis_qm_kauf_bestand: 5165.4079758443,
    zeit: '2023-Q2',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    _angebote_miete_neubau: 100,
    mittl_preis_qm_miete_neubau: 30.0757000351,
    _angebote_miete_bestand: 241,
    mittl_preis_qm_miete_bestand: 18.6057676497,
    _angebote_kauf_neubau: 238,
    mittl_preis_qm_kauf_neubau: 9855.1811051569,
    _angebote_kauf_bestand: 1158,
    mittl_preis_qm_kauf_bestand: 6293.2424050761,
    zeit: '2023-Q2',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 136,
    mittl_preis_qm_miete_neubau: 22.3932353188,
    _angebote_miete_bestand: 433,
    mittl_preis_qm_miete_bestand: 16.8945958554,
    _angebote_kauf_neubau: 327,
    mittl_preis_qm_kauf_neubau: 7882.2746947869,
    _angebote_kauf_bestand: 1256,
    mittl_preis_qm_kauf_bestand: 5881.5987605198,
    zeit: '2023-Q2',
  },
  {
    name: 'Friedrichshain',
    _angebote_miete_neubau: 74,
    mittl_preis_qm_miete_neubau: 31.9870270909,
    _angebote_miete_bestand: 144,
    mittl_preis_qm_miete_bestand: 18.7740278244,
    _angebote_kauf_neubau: 183,
    mittl_preis_qm_kauf_neubau: 9766.2441806481,
    _angebote_kauf_bestand: 803,
    mittl_preis_qm_kauf_bestand: 6072.0951443075,
    zeit: '2023-Q2',
  },
  {
    name: 'Tempelhof',
    _angebote_miete_neubau: null,
    mittl_preis_qm_miete_neubau: null,
    _angebote_miete_bestand: 41,
    mittl_preis_qm_miete_bestand: 14.3717072417,
    _angebote_kauf_neubau: null,
    mittl_preis_qm_kauf_neubau: null,
    _angebote_kauf_bestand: 175,
    mittl_preis_qm_kauf_bestand: 4571.375140904,
    zeit: '2023-Q2',
  },
  {
    name: 'Wedding',
    _angebote_miete_neubau: 10,
    mittl_preis_qm_miete_neubau: 23.9689998627,
    _angebote_miete_bestand: 82,
    mittl_preis_qm_miete_bestand: 12.6749999698,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 7567.5610894097,
    _angebote_kauf_bestand: 237,
    mittl_preis_qm_kauf_bestand: 4465.7036019498,
    zeit: '2023-Q2',
  },
  {
    name: 'Kreuzberg',
    _angebote_miete_neubau: 25,
    mittl_preis_qm_miete_neubau: 25.8572000122,
    _angebote_miete_bestand: 96,
    mittl_preis_qm_miete_bestand: 18.4378124724,
    _angebote_kauf_neubau: 56,
    mittl_preis_qm_kauf_neubau: 10244.305507115,
    _angebote_kauf_bestand: 356,
    mittl_preis_qm_kauf_bestand: 6815.2575395563,
    zeit: '2023-Q2',
  },
  {
    name: 'Charlottenburg',
    _angebote_miete_neubau: 57,
    mittl_preis_qm_miete_neubau: 24.4192981051,
    _angebote_miete_bestand: 165,
    mittl_preis_qm_miete_bestand: 19.4761211915,
    _angebote_kauf_neubau: 90,
    mittl_preis_qm_kauf_neubau: 10833.1164171007,
    _angebote_kauf_bestand: 847,
    mittl_preis_qm_kauf_bestand: 6793.6794551773,
    zeit: '2023-Q2',
  },
  {
    name: 'Köpenick',
    _angebote_miete_neubau: 136,
    mittl_preis_qm_miete_neubau: 17.3337500376,
    _angebote_miete_bestand: 176,
    mittl_preis_qm_miete_bestand: 12.1307954517,
    _angebote_kauf_neubau: 85,
    mittl_preis_qm_kauf_neubau: 7809.5859949449,
    _angebote_kauf_bestand: 208,
    mittl_preis_qm_kauf_bestand: 4679.0541299673,
    zeit: '2023-Q2',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 29,
    mittl_preis_qm_miete_neubau: 23.7203448723,
    _angebote_miete_bestand: 110,
    mittl_preis_qm_miete_bestand: 15.2237273,
    _angebote_kauf_neubau: 19,
    mittl_preis_qm_kauf_neubau: 7871.9173519737,
    _angebote_kauf_bestand: 411,
    mittl_preis_qm_kauf_bestand: 5579.2618826984,
    zeit: '2023-Q2',
  },
  {
    name: 'Steglitz',
    _angebote_miete_neubau: null,
    mittl_preis_qm_miete_neubau: null,
    _angebote_miete_bestand: 64,
    mittl_preis_qm_miete_bestand: 15.1984374821,
    _angebote_kauf_neubau: 14,
    mittl_preis_qm_kauf_neubau: 8098.5428292411,
    _angebote_kauf_bestand: 384,
    mittl_preis_qm_kauf_bestand: 5188.4385401408,
    zeit: '2023-Q2',
  },
  {
    name: 'Schöneberg',
    _angebote_miete_neubau: 20,
    mittl_preis_qm_miete_neubau: 26.1229999542,
    _angebote_miete_bestand: 77,
    mittl_preis_qm_miete_bestand: 18.0480519394,
    _angebote_kauf_neubau: 33,
    mittl_preis_qm_kauf_neubau: 11843.6187263258,
    _angebote_kauf_bestand: 408,
    mittl_preis_qm_kauf_bestand: 5816.8973807541,
    zeit: '2023-Q2',
  },
  {
    name: 'Wilmersdorf',
    _angebote_miete_neubau: 39,
    mittl_preis_qm_miete_neubau: 28.8989743453,
    _angebote_miete_bestand: 110,
    mittl_preis_qm_miete_bestand: 22.2987272436,
    _angebote_kauf_neubau: 134,
    mittl_preis_qm_kauf_neubau: 14529.8268241313,
    _angebote_kauf_bestand: 639,
    mittl_preis_qm_kauf_bestand: 6454.4236340351,
    zeit: '2023-Q2',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 63,
    mittl_preis_qm_miete_neubau: 30.0063492306,
    _angebote_miete_bestand: 208,
    mittl_preis_qm_miete_bestand: 24.0121635015,
    _angebote_kauf_neubau: 54,
    mittl_preis_qm_kauf_neubau: 10840.7410933883,
    _angebote_kauf_bestand: 532,
    mittl_preis_qm_kauf_bestand: 8303.8746126792,
    zeit: '2023-Q2',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 18,
    mittl_preis_qm_miete_neubau: 19.4205556446,
    _angebote_miete_bestand: 63,
    mittl_preis_qm_miete_bestand: 11.6028571583,
    _angebote_kauf_neubau: 52,
    mittl_preis_qm_kauf_neubau: 7312.4009540264,
    _angebote_kauf_bestand: 313,
    mittl_preis_qm_kauf_bestand: 4194.3613936452,
    zeit: '2023-Q2',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 39,
    mittl_preis_qm_miete_neubau: 23.2441025269,
    _angebote_miete_bestand: 44,
    mittl_preis_qm_miete_bestand: 15.3409090801,
    _angebote_kauf_neubau: 43,
    mittl_preis_qm_kauf_neubau: 7704.6562613554,
    _angebote_kauf_bestand: 214,
    mittl_preis_qm_kauf_bestand: 5455.577978972,
    zeit: '2023-Q2',
  },
  {
    name: 'Zehlendorf',
    _angebote_miete_neubau: 5,
    mittl_preis_qm_miete_neubau: 21.1900001526,
    _angebote_miete_bestand: 57,
    mittl_preis_qm_miete_bestand: 13.2308771652,
    _angebote_kauf_neubau: 20,
    mittl_preis_qm_kauf_neubau: 10147.7969726562,
    _angebote_kauf_bestand: 207,
    mittl_preis_qm_kauf_bestand: 5351.3902369697,
    zeit: '2023-Q2',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 10,
    mittl_preis_qm_miete_neubau: 26.4469997406,
    _angebote_miete_bestand: 18,
    mittl_preis_qm_miete_bestand: 10.8200000127,
    _angebote_kauf_neubau: 8,
    mittl_preis_qm_kauf_neubau: 6897.9686889648,
    _angebote_kauf_bestand: 65,
    mittl_preis_qm_kauf_bestand: 4577.986309345,
    zeit: '2023-Q2',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 15,
    mittl_preis_qm_miete_neubau: 17.6859999339,
    _angebote_miete_bestand: 59,
    mittl_preis_qm_miete_bestand: 11.8493220604,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 6786.3021918403,
    _angebote_kauf_bestand: 154,
    mittl_preis_qm_kauf_bestand: 4212.7913517147,
    zeit: '2023-Q2',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 68,
    mittl_preis_qm_miete_neubau: 20.2030882835,
    _angebote_miete_bestand: 265,
    mittl_preis_qm_miete_bestand: 14.4686037495,
    _angebote_kauf_neubau: 33,
    mittl_preis_qm_kauf_neubau: 7582.501509233,
    _angebote_kauf_bestand: 732,
    mittl_preis_qm_kauf_bestand: 4823.0917618548,
    zeit: '2023-Q4',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    _angebote_miete_neubau: 170,
    mittl_preis_qm_miete_neubau: 26.8336470211,
    _angebote_miete_bestand: 551,
    mittl_preis_qm_miete_bestand: 19.6864609727,
    _angebote_kauf_neubau: 249,
    mittl_preis_qm_kauf_neubau: 10992.0142836973,
    _angebote_kauf_bestand: 2047,
    mittl_preis_qm_kauf_bestand: 6436.4937360696,
    zeit: '2023-Q4',
  },
  {
    name: 'Treptow-Köpenick',
    _angebote_miete_neubau: 288,
    mittl_preis_qm_miete_neubau: 22.2859721581,
    _angebote_miete_bestand: 412,
    mittl_preis_qm_miete_bestand: 14.1311407656,
    _angebote_kauf_neubau: 195,
    mittl_preis_qm_kauf_neubau: 7114.7366110777,
    _angebote_kauf_bestand: 560,
    mittl_preis_qm_kauf_bestand: 4384.7525669643,
    zeit: '2023-Q4',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 27,
    mittl_preis_qm_miete_neubau: 18.9622222759,
    _angebote_miete_bestand: 225,
    mittl_preis_qm_miete_bestand: 12.3396444575,
    _angebote_kauf_neubau: 107,
    mittl_preis_qm_kauf_neubau: 7272.4498850029,
    _angebote_kauf_bestand: 513,
    mittl_preis_qm_kauf_bestand: 3962.2705282765,
    zeit: '2023-Q4',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 248,
    mittl_preis_qm_miete_neubau: 27.5721370405,
    _angebote_miete_bestand: 690,
    mittl_preis_qm_miete_bestand: 19.758304332,
    _angebote_kauf_neubau: 136,
    mittl_preis_qm_kauf_neubau: 9274.3874188591,
    _angebote_kauf_bestand: 1429,
    mittl_preis_qm_kauf_bestand: 6403.7092242444,
    zeit: '2023-Q4',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 99,
    mittl_preis_qm_miete_neubau: 18.0461616323,
    _angebote_miete_bestand: 260,
    mittl_preis_qm_miete_bestand: 11.3552308119,
    _angebote_kauf_neubau: 65,
    mittl_preis_qm_kauf_neubau: 6700.9482797476,
    _angebote_kauf_bestand: 397,
    mittl_preis_qm_kauf_bestand: 3780.7335281949,
    zeit: '2023-Q4',
  },
  {
    name: 'Marzahn-Hellersdorf',
    _angebote_miete_neubau: 72,
    mittl_preis_qm_miete_neubau: 15.3374999629,
    _angebote_miete_bestand: 232,
    mittl_preis_qm_miete_bestand: 9.6272845248,
    _angebote_kauf_neubau: 40,
    mittl_preis_qm_kauf_neubau: 5270.2977050781,
    _angebote_kauf_bestand: 101,
    mittl_preis_qm_kauf_bestand: 3824.6160248105,
    zeit: '2023-Q4',
  },
  {
    name: 'Steglitz-Zehlendorf',
    _angebote_miete_neubau: 42,
    mittl_preis_qm_miete_neubau: 21.844999881,
    _angebote_miete_bestand: 354,
    mittl_preis_qm_miete_bestand: 15.0748870171,
    _angebote_kauf_neubau: 115,
    mittl_preis_qm_kauf_neubau: 8501.5643469769,
    _angebote_kauf_bestand: 1167,
    mittl_preis_qm_kauf_bestand: 5146.4962728283,
    zeit: '2023-Q4',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 229,
    mittl_preis_qm_miete_neubau: 19.9159389562,
    _angebote_miete_bestand: 181,
    mittl_preis_qm_miete_bestand: 13.9907182435,
    _angebote_kauf_neubau: 118,
    mittl_preis_qm_kauf_neubau: 7175.8603639764,
    _angebote_kauf_bestand: 235,
    mittl_preis_qm_kauf_bestand: 4307.3067133477,
    zeit: '2023-Q4',
  },
  {
    name: 'Tempelhof-Schöneberg',
    _angebote_miete_neubau: 86,
    mittl_preis_qm_miete_neubau: 20.317906912,
    _angebote_miete_bestand: 308,
    mittl_preis_qm_miete_bestand: 15.5024999922,
    _angebote_kauf_neubau: 138,
    mittl_preis_qm_kauf_neubau: 8542.5340700011,
    _angebote_kauf_bestand: 1030,
    mittl_preis_qm_kauf_bestand: 5206.5114381068,
    zeit: '2023-Q4',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    _angebote_miete_neubau: 136,
    mittl_preis_qm_miete_neubau: 25.7863234702,
    _angebote_miete_bestand: 320,
    mittl_preis_qm_miete_bestand: 21.1181562424,
    _angebote_kauf_neubau: 300,
    mittl_preis_qm_kauf_neubau: 9732.7046826172,
    _angebote_kauf_bestand: 1235,
    mittl_preis_qm_kauf_bestand: 6076.6326691786,
    zeit: '2023-Q4',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 165,
    mittl_preis_qm_miete_neubau: 23.6753333525,
    _angebote_miete_bestand: 489,
    mittl_preis_qm_miete_bestand: 16.7375869127,
    _angebote_kauf_neubau: 289,
    mittl_preis_qm_kauf_neubau: 7443.8139209153,
    _angebote_kauf_bestand: 1306,
    mittl_preis_qm_kauf_bestand: 5755.3019150271,
    zeit: '2023-Q4',
  },
  {
    name: 'Friedrichshain',
    _angebote_miete_neubau: 88,
    mittl_preis_qm_miete_neubau: 26.2470454411,
    _angebote_miete_bestand: 186,
    mittl_preis_qm_miete_bestand: 21.3509139502,
    _angebote_kauf_neubau: 189,
    mittl_preis_qm_kauf_neubau: 9441.1360212054,
    _angebote_kauf_bestand: 786,
    mittl_preis_qm_kauf_bestand: 5838.1454537661,
    zeit: '2023-Q4',
  },
  {
    name: 'Tempelhof',
    _angebote_miete_neubau: 9,
    mittl_preis_qm_miete_neubau: 24.0555555556,
    _angebote_miete_bestand: 41,
    mittl_preis_qm_miete_bestand: 14.0460975693,
    _angebote_kauf_neubau: 8,
    mittl_preis_qm_kauf_neubau: 6688.505065918,
    _angebote_kauf_bestand: 172,
    mittl_preis_qm_kauf_bestand: 4814.3473808821,
    zeit: '2023-Q4',
  },
  {
    name: 'Wedding',
    _angebote_miete_neubau: 10,
    mittl_preis_qm_miete_neubau: 23.8700000763,
    _angebote_miete_bestand: 93,
    mittl_preis_qm_miete_bestand: 16.0019354051,
    _angebote_kauf_neubau: 18,
    mittl_preis_qm_kauf_neubau: 7618.1972384983,
    _angebote_kauf_bestand: 250,
    mittl_preis_qm_kauf_bestand: 4393.3498828125,
    zeit: '2023-Q4',
  },
  {
    name: 'Kreuzberg',
    _angebote_miete_neubau: 47,
    mittl_preis_qm_miete_neubau: 25.4663828586,
    _angebote_miete_bestand: 136,
    mittl_preis_qm_miete_bestand: 20.6663235531,
    _angebote_kauf_neubau: 108,
    mittl_preis_qm_kauf_neubau: 10166.1116446036,
    _angebote_kauf_bestand: 448,
    mittl_preis_qm_kauf_bestand: 6559.072996412,
    zeit: '2023-Q4',
  },
  {
    name: 'Charlottenburg',
    _angebote_miete_neubau: 72,
    mittl_preis_qm_miete_neubau: 27.8012500074,
    _angebote_miete_bestand: 217,
    mittl_preis_qm_miete_bestand: 20.389907793,
    _angebote_kauf_neubau: 85,
    mittl_preis_qm_kauf_neubau: 10234.4179342831,
    _angebote_kauf_bestand: 864,
    mittl_preis_qm_kauf_bestand: 6642.7720407557,
    zeit: '2023-Q4',
  },
  {
    name: 'Köpenick',
    _angebote_miete_neubau: 98,
    mittl_preis_qm_miete_neubau: 18.9403060991,
    _angebote_miete_bestand: 148,
    mittl_preis_qm_miete_bestand: 12.9400675426,
    _angebote_kauf_neubau: 93,
    mittl_preis_qm_kauf_neubau: 7654.8025663642,
    _angebote_kauf_bestand: 206,
    mittl_preis_qm_kauf_bestand: 4539.414652704,
    zeit: '2023-Q4',
  },
  {
    name: 'Neukölln',
    _angebote_miete_neubau: 42,
    mittl_preis_qm_miete_neubau: 21.9576191221,
    _angebote_miete_bestand: 150,
    mittl_preis_qm_miete_bestand: 16.7534666284,
    _angebote_kauf_neubau: 24,
    mittl_preis_qm_kauf_neubau: 8129.225402832,
    _angebote_kauf_bestand: 486,
    mittl_preis_qm_kauf_bestand: 5309.6723853845,
    zeit: '2023-Q4',
  },
  {
    name: 'Steglitz',
    _angebote_miete_neubau: 8,
    mittl_preis_qm_miete_neubau: 24.9562499523,
    _angebote_miete_bestand: 69,
    mittl_preis_qm_miete_bestand: 14.9379710736,
    _angebote_kauf_neubau: 40,
    mittl_preis_qm_kauf_neubau: 8046.3087158203,
    _angebote_kauf_bestand: 403,
    mittl_preis_qm_kauf_bestand: 4997.242357732,
    zeit: '2023-Q4',
  },
  {
    name: 'Schöneberg',
    _angebote_miete_neubau: 28,
    mittl_preis_qm_miete_neubau: 27.4482141903,
    _angebote_miete_bestand: 104,
    mittl_preis_qm_miete_bestand: 20.9324038854,
    _angebote_kauf_neubau: 46,
    mittl_preis_qm_kauf_neubau: 11861.9095299762,
    _angebote_kauf_bestand: 416,
    mittl_preis_qm_kauf_bestand: 5704.538002601,
    zeit: '2023-Q4',
  },
  {
    name: 'Wilmersdorf',
    _angebote_miete_neubau: 55,
    mittl_preis_qm_miete_neubau: 25.7909089869,
    _angebote_miete_bestand: 149,
    mittl_preis_qm_miete_bestand: 21.6228187932,
    _angebote_kauf_neubau: 133,
    mittl_preis_qm_kauf_neubau: 12705.0065312206,
    _angebote_kauf_bestand: 684,
    mittl_preis_qm_kauf_bestand: 6366.6113149186,
    zeit: '2023-Q4',
  },
  {
    name: 'Mitte',
    _angebote_miete_neubau: 108,
    mittl_preis_qm_miete_neubau: 29.4628704389,
    _angebote_miete_bestand: 290,
    mittl_preis_qm_miete_bestand: 22.6366551925,
    _angebote_kauf_neubau: 30,
    mittl_preis_qm_kauf_neubau: 11666.1009928385,
    _angebote_kauf_bestand: 540,
    mittl_preis_qm_kauf_bestand: 8062.4520571108,
    zeit: '2023-Q4',
  },
  {
    name: 'Reinickendorf',
    _angebote_miete_neubau: 19,
    mittl_preis_qm_miete_neubau: 19.7726316954,
    _angebote_miete_bestand: 85,
    mittl_preis_qm_miete_bestand: 11.9507058985,
    _angebote_kauf_neubau: 93,
    mittl_preis_qm_kauf_neubau: 7213.524813088,
    _angebote_kauf_bestand: 311,
    mittl_preis_qm_kauf_bestand: 3832.3846635726,
    zeit: '2023-Q4',
  },
  {
    name: 'Pankow',
    _angebote_miete_neubau: 36,
    mittl_preis_qm_miete_neubau: 23.2094444169,
    _angebote_miete_bestand: 71,
    mittl_preis_qm_miete_bestand: 15.4505633636,
    _angebote_kauf_neubau: 44,
    mittl_preis_qm_kauf_neubau: 7756.4426824396,
    _angebote_kauf_bestand: 199,
    mittl_preis_qm_kauf_bestand: 4972.2849759049,
    zeit: '2023-Q4',
  },
  {
    name: 'Zehlendorf',
    _angebote_miete_neubau: 1,
    mittl_preis_qm_miete_neubau: 18,
    _angebote_miete_bestand: 93,
    mittl_preis_qm_miete_bestand: 14.5936558836,
    _angebote_kauf_neubau: 29,
    mittl_preis_qm_kauf_neubau: 10149.0999966325,
    _angebote_kauf_bestand: 199,
    mittl_preis_qm_kauf_bestand: 4937.8688375962,
    zeit: '2023-Q4',
  },
  {
    name: 'Lichtenberg',
    _angebote_miete_neubau: 11,
    mittl_preis_qm_miete_neubau: 24.400000052,
    _angebote_miete_bestand: 12,
    mittl_preis_qm_miete_bestand: 15.0716665586,
    _angebote_kauf_neubau: 10,
    mittl_preis_qm_kauf_neubau: 8041.673046875,
    _angebote_kauf_bestand: 51,
    mittl_preis_qm_kauf_bestand: 4279.9423588771,
    zeit: '2023-Q4',
  },
  {
    name: 'Spandau',
    _angebote_miete_neubau: 9,
    mittl_preis_qm_miete_neubau: 18.9788890415,
    _angebote_miete_bestand: 46,
    mittl_preis_qm_miete_bestand: 12.38021749,
    _angebote_kauf_neubau: 9,
    mittl_preis_qm_kauf_neubau: 7042.7154947917,
    _angebote_kauf_bestand: 168,
    mittl_preis_qm_kauf_bestand: 3937.871560233,
    zeit: '2023-Q4',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5674.89529,
    mittl_preis_qm_kauf_neubau: 8623.012745,
    mittl_preis_qm_miete_bestand: 12.56980179,
    mittl_preis_qm_miete_neubau: 18.63314287,
    _angebote_kauf_bestand: 1671,
    _angebote_kauf_neubau: 256,
    _angebote_miete_bestand: 555,
    _angebote_miete_neubau: 210,
    zeit: '2020-Q3',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 6110.866491,
    mittl_preis_qm_kauf_neubau: 10826.83243,
    mittl_preis_qm_miete_bestand: 13.64259329,
    mittl_preis_qm_miete_neubau: 20.35688315,
    _angebote_kauf_bestand: 1315,
    _angebote_kauf_neubau: 159,
    _angebote_miete_bestand: 536,
    _angebote_miete_neubau: 154,
    zeit: '2021-Q3',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5707.821845,
    mittl_preis_qm_kauf_neubau: 9061.498619,
    mittl_preis_qm_miete_bestand: 12.74590246,
    mittl_preis_qm_miete_neubau: 19.46439792,
    _angebote_kauf_bestand: 1602,
    _angebote_kauf_neubau: 240,
    _angebote_miete_bestand: 410,
    _angebote_miete_neubau: 191,
    zeit: '2020-Q4',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5849.120949,
    mittl_preis_qm_kauf_neubau: 10462.50399,
    mittl_preis_qm_miete_bestand: 13.76623158,
    mittl_preis_qm_miete_neubau: 20.03251611,
    _angebote_kauf_bestand: 1337,
    _angebote_kauf_neubau: 183,
    _angebote_miete_bestand: 544,
    _angebote_miete_neubau: 155,
    zeit: '2021-Q2',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5830.773976,
    mittl_preis_qm_kauf_neubau: 9696.656457,
    mittl_preis_qm_miete_bestand: 13.01114074,
    mittl_preis_qm_miete_neubau: 19.71307264,
    _angebote_kauf_bestand: 1402,
    _angebote_kauf_neubau: 226,
    _angebote_miete_bestand: 412,
    _angebote_miete_neubau: 179,
    zeit: '2021-Q1',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 6282.185425,
    mittl_preis_qm_kauf_neubau: 11971.98828,
    mittl_preis_qm_miete_bestand: 14.27069718,
    mittl_preis_qm_miete_neubau: 20.34704539,
    _angebote_kauf_bestand: 1235,
    _angebote_kauf_neubau: 150,
    _angebote_miete_bestand: 502,
    _angebote_miete_neubau: 132,
    zeit: '2021-Q4',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5488.186159,
    mittl_preis_qm_kauf_neubau: 8172.713001,
    mittl_preis_qm_miete_bestand: 12.58054263,
    mittl_preis_qm_miete_neubau: 18.08389532,
    _angebote_kauf_bestand: 1617,
    _angebote_kauf_neubau: 304,
    _angebote_miete_bestand: 774,
    _angebote_miete_neubau: 172,
    zeit: '2020-Q1',
  },
  {
    name: 'Charlottenburg-Wilmersdorf',
    mittl_preis_qm_kauf_bestand: 5604.990764,
    mittl_preis_qm_kauf_neubau: 8283.745774,
    mittl_preis_qm_miete_bestand: 12.49058726,
    mittl_preis_qm_miete_neubau: 18.33163159,
    _angebote_kauf_bestand: 1593,
    _angebote_kauf_neubau: 234,
    _angebote_miete_bestand: 596,
    _angebote_miete_neubau: 190,
    zeit: '2020-Q2',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5495.282419,
    mittl_preis_qm_kauf_neubau: 8139.403814,
    mittl_preis_qm_miete_bestand: 14.43980318,
    mittl_preis_qm_miete_neubau: 19.36054051,
    _angebote_kauf_bestand: 1000,
    _angebote_kauf_neubau: 97,
    _angebote_miete_bestand: 254,
    _angebote_miete_neubau: 111,
    zeit: '2020-Q4',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5239.397482,
    mittl_preis_qm_kauf_neubau: 7783.662477,
    mittl_preis_qm_miete_bestand: 14.15479623,
    mittl_preis_qm_miete_neubau: 19.04696717,
    _angebote_kauf_bestand: 999,
    _angebote_kauf_neubau: 81,
    _angebote_miete_bestand: 319,
    _angebote_miete_neubau: 122,
    zeit: '2020-Q2',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5768.536039,
    mittl_preis_qm_kauf_neubau: 8918.765573,
    mittl_preis_qm_miete_bestand: 15.10041201,
    mittl_preis_qm_miete_neubau: 19.28971432,
    _angebote_kauf_bestand: 853,
    _angebote_kauf_neubau: 84,
    _angebote_miete_bestand: 267,
    _angebote_miete_neubau: 70,
    zeit: '2021-Q2',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5988.997173,
    mittl_preis_qm_kauf_neubau: 9414.655003,
    mittl_preis_qm_miete_bestand: 15.39112281,
    mittl_preis_qm_miete_neubau: 21.3845555,
    _angebote_kauf_bestand: 594,
    _angebote_kauf_neubau: 85,
    _angebote_miete_bestand: 285,
    _angebote_miete_neubau: 90,
    zeit: '2021-Q4',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5250.657541,
    mittl_preis_qm_kauf_neubau: 8034.582733,
    mittl_preis_qm_miete_bestand: 13.88378699,
    mittl_preis_qm_miete_neubau: 18.58042553,
    _angebote_kauf_bestand: 986,
    _angebote_kauf_neubau: 80,
    _angebote_miete_bestand: 507,
    _angebote_miete_neubau: 141,
    zeit: '2020-Q1',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5285.296048,
    mittl_preis_qm_kauf_neubau: 7782.441677,
    mittl_preis_qm_miete_bestand: 14.80281458,
    mittl_preis_qm_miete_neubau: 19.30228347,
    _angebote_kauf_bestand: 1048,
    _angebote_kauf_neubau: 101,
    _angebote_miete_bestand: 302,
    _angebote_miete_neubau: 127,
    zeit: '2020-Q3',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5576.91972,
    mittl_preis_qm_kauf_neubau: 8362.965332,
    mittl_preis_qm_miete_bestand: 14.79678392,
    mittl_preis_qm_miete_neubau: 19.31684203,
    _angebote_kauf_bestand: 891,
    _angebote_kauf_neubau: 112,
    _angebote_miete_bestand: 199,
    _angebote_miete_neubau: 76,
    zeit: '2021-Q1',
  },
  {
    name: 'Friedrichshain-Kreuzberg',
    mittl_preis_qm_kauf_bestand: 5818.507096,
    mittl_preis_qm_kauf_neubau: 9299.117401,
    mittl_preis_qm_miete_bestand: 14.91557194,
    mittl_preis_qm_miete_neubau: 20.1830986,
    _angebote_kauf_bestand: 725,
    _angebote_kauf_neubau: 80,
    _angebote_miete_bestand: 271,
    _angebote_miete_neubau: 71,
    zeit: '2021-Q3',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 3763.930398,
    mittl_preis_qm_kauf_neubau: 5845.014859,
    mittl_preis_qm_miete_bestand: 8.001152657,
    mittl_preis_qm_miete_neubau: 12.90821914,
    _angebote_kauf_bestand: 200,
    _angebote_kauf_neubau: 132,
    _angebote_miete_bestand: 642,
    _angebote_miete_neubau: 146,
    zeit: '2020-Q2',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 3937.084638,
    mittl_preis_qm_kauf_neubau: 6105.142428,
    mittl_preis_qm_miete_bestand: 7.884260443,
    mittl_preis_qm_miete_neubau: 12.43067031,
    _angebote_kauf_bestand: 211,
    _angebote_kauf_neubau: 120,
    _angebote_miete_bestand: 622,
    _angebote_miete_neubau: 179,
    zeit: '2020-Q4',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 3703.939073,
    mittl_preis_qm_kauf_neubau: 5381.171083,
    mittl_preis_qm_miete_bestand: 8.573810202,
    mittl_preis_qm_miete_neubau: 13.00601153,
    _angebote_kauf_bestand: 205,
    _angebote_kauf_neubau: 119,
    _angebote_miete_bestand: 706,
    _angebote_miete_neubau: 173,
    zeit: '2020-Q1',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 4395.296812,
    mittl_preis_qm_kauf_neubau: 6573.416937,
    mittl_preis_qm_miete_bestand: 9.123915104,
    mittl_preis_qm_miete_neubau: 12.84726664,
    _angebote_kauf_bestand: 185,
    _angebote_kauf_neubau: 98,
    _angebote_miete_bestand: 424,
    _angebote_miete_neubau: 150,
    zeit: '2021-Q3',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 4199.491226,
    mittl_preis_qm_kauf_neubau: 6338.998871,
    mittl_preis_qm_miete_bestand: 8.883108701,
    mittl_preis_qm_miete_neubau: 14.36911107,
    _angebote_kauf_bestand: 180,
    _angebote_kauf_neubau: 106,
    _angebote_miete_bestand: 460,
    _angebote_miete_neubau: 135,
    zeit: '2021-Q2',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 3769.331599,
    mittl_preis_qm_kauf_neubau: 5927.916729,
    mittl_preis_qm_miete_bestand: 7.497266848,
    mittl_preis_qm_miete_neubau: 13.02199994,
    _angebote_kauf_bestand: 188,
    _angebote_kauf_neubau: 128,
    _angebote_miete_bestand: 772,
    _angebote_miete_neubau: 155,
    zeit: '2020-Q3',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 4105.826258,
    mittl_preis_qm_kauf_neubau: 6310.535527,
    mittl_preis_qm_miete_bestand: 7.717642705,
    mittl_preis_qm_miete_neubau: 13.38539466,
    _angebote_kauf_bestand: 184,
    _angebote_kauf_neubau: 116,
    _angebote_miete_bestand: 543,
    _angebote_miete_neubau: 152,
    zeit: '2021-Q1',
  },
  {
    name: 'Lichtenberg',
    mittl_preis_qm_kauf_bestand: 4520.612729,
    mittl_preis_qm_kauf_neubau: 6619.407098,
    mittl_preis_qm_miete_bestand: 9.139478905,
    mittl_preis_qm_miete_neubau: 13.6329605,
    _angebote_kauf_bestand: 165,
    _angebote_kauf_neubau: 72,
    _angebote_miete_bestand: 403,
    _angebote_miete_neubau: 152,
    zeit: '2021-Q4',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3731.90144,
    mittl_preis_qm_kauf_neubau: 5126.297863,
    mittl_preis_qm_miete_bestand: 8.517563732,
    mittl_preis_qm_miete_neubau: 10.33421483,
    _angebote_kauf_bestand: 77,
    _angebote_kauf_neubau: 43,
    _angebote_miete_bestand: 353,
    _angebote_miete_neubau: 121,
    zeit: '2021-Q2',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3709.528828,
    mittl_preis_qm_kauf_neubau: 4846.066607,
    mittl_preis_qm_miete_bestand: 8.573366087,
    mittl_preis_qm_miete_neubau: 10.59186911,
    _angebote_kauf_bestand: 77,
    _angebote_kauf_neubau: 39,
    _angebote_miete_bestand: 407,
    _angebote_miete_neubau: 107,
    zeit: '2021-Q3',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3669.074711,
    mittl_preis_qm_kauf_neubau: 5233.245382,
    mittl_preis_qm_miete_bestand: 8.12716621,
    mittl_preis_qm_miete_neubau: 12.12184205,
    _angebote_kauf_bestand: 68,
    _angebote_kauf_neubau: 24,
    _angebote_miete_bestand: 367,
    _angebote_miete_neubau: 76,
    zeit: '2021-Q4',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3645.345756,
    mittl_preis_qm_kauf_neubau: 5236.606155,
    mittl_preis_qm_miete_bestand: 7.61353224,
    mittl_preis_qm_miete_neubau: 10.01557684,
    _angebote_kauf_bestand: 71,
    _angebote_kauf_neubau: 42,
    _angebote_miete_bestand: 419,
    _angebote_miete_neubau: 104,
    zeit: '2021-Q1',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3078.292972,
    mittl_preis_qm_kauf_neubau: 4585.79485,
    mittl_preis_qm_miete_bestand: 7.337231627,
    mittl_preis_qm_miete_neubau: 9.882454534,
    _angebote_kauf_bestand: 77,
    _angebote_kauf_neubau: 41,
    _angebote_miete_bestand: 531,
    _angebote_miete_neubau: 110,
    zeit: '2020-Q3',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 2969.562455,
    mittl_preis_qm_kauf_neubau: 4337.810419,
    mittl_preis_qm_miete_bestand: 7.428225108,
    mittl_preis_qm_miete_neubau: 9.6655555,
    _angebote_kauf_bestand: 65,
    _angebote_kauf_neubau: 23,
    _angebote_miete_bestand: 462,
    _angebote_miete_neubau: 63,
    zeit: '2020-Q2',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 2832.929346,
    mittl_preis_qm_kauf_neubau: 4549.341833,
    mittl_preis_qm_miete_bestand: 8.114810676,
    mittl_preis_qm_miete_neubau: 10.51306813,
    _angebote_kauf_bestand: 78,
    _angebote_kauf_neubau: 27,
    _angebote_miete_bestand: 449,
    _angebote_miete_neubau: 88,
    zeit: '2020-Q1',
  },
  {
    name: 'Marzahn-Hellersdorf',
    mittl_preis_qm_kauf_bestand: 3088.38998,
    mittl_preis_qm_kauf_neubau: 4914.954174,
    mittl_preis_qm_miete_bestand: 7.608736386,
    mittl_preis_qm_miete_neubau: 10.06991665,
    _angebote_kauf_bestand: 67,
    _angebote_kauf_neubau: 64,
    _angebote_miete_bestand: 459,
    _angebote_miete_neubau: 120,
    zeit: '2020-Q4',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5383.203267,
    mittl_preis_qm_kauf_neubau: 8336.073565,
    mittl_preis_qm_miete_bestand: 13.55829269,
    mittl_preis_qm_miete_neubau: 18.85124226,
    _angebote_kauf_bestand: 1158,
    _angebote_kauf_neubau: 245,
    _angebote_miete_bestand: 902,
    _angebote_miete_neubau: 322,
    zeit: '2020-Q1',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5978.23669,
    mittl_preis_qm_kauf_neubau: 9030.19484,
    mittl_preis_qm_miete_bestand: 14.76119832,
    mittl_preis_qm_miete_neubau: 20.65944441,
    _angebote_kauf_bestand: 1214,
    _angebote_kauf_neubau: 175,
    _angebote_miete_bestand: 726,
    _angebote_miete_neubau: 252,
    zeit: '2021-Q2',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5523.102181,
    mittl_preis_qm_kauf_neubau: 8907.695173,
    mittl_preis_qm_miete_bestand: 13.70453769,
    mittl_preis_qm_miete_neubau: 19.44364928,
    _angebote_kauf_bestand: 1297,
    _angebote_kauf_neubau: 235,
    _angebote_miete_bestand: 703,
    _angebote_miete_neubau: 422,
    zeit: '2020-Q3',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 6111.972538,
    mittl_preis_qm_kauf_neubau: 9653.016666,
    mittl_preis_qm_miete_bestand: 14.85101321,
    mittl_preis_qm_miete_neubau: 22.19107956,
    _angebote_kauf_bestand: 974,
    _angebote_kauf_neubau: 205,
    _angebote_miete_bestand: 681,
    _angebote_miete_neubau: 176,
    zeit: '2021-Q4',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5516.88495,
    mittl_preis_qm_kauf_neubau: 8153.466114,
    mittl_preis_qm_miete_bestand: 13.1983199,
    mittl_preis_qm_miete_neubau: 19.25710913,
    _angebote_kauf_bestand: 1154,
    _angebote_kauf_neubau: 208,
    _angebote_miete_bestand: 744,
    _angebote_miete_neubau: 339,
    zeit: '2020-Q2',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5847.982652,
    mittl_preis_qm_kauf_neubau: 8602.099447,
    mittl_preis_qm_miete_bestand: 14.51843697,
    mittl_preis_qm_miete_neubau: 20.19193978,
    _angebote_kauf_bestand: 1276,
    _angebote_kauf_neubau: 190,
    _angebote_miete_bestand: 595,
    _angebote_miete_neubau: 299,
    zeit: '2021-Q1',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 5628.924351,
    mittl_preis_qm_kauf_neubau: 9208.502381,
    mittl_preis_qm_miete_bestand: 13.53019767,
    mittl_preis_qm_miete_neubau: 19.56058981,
    _angebote_kauf_bestand: 1373,
    _angebote_kauf_neubau: 234,
    _angebote_miete_bestand: 607,
    _angebote_miete_neubau: 373,
    zeit: '2020-Q4',
  },
  {
    name: 'Mitte',
    mittl_preis_qm_kauf_bestand: 6059.90579,
    mittl_preis_qm_kauf_neubau: 9441.319877,
    mittl_preis_qm_miete_bestand: 14.59394271,
    mittl_preis_qm_miete_neubau: 21.47111109,
    _angebote_kauf_bestand: 1074,
    _angebote_kauf_neubau: 195,
    _angebote_miete_bestand: 733,
    _angebote_miete_neubau: 225,
    zeit: '2021-Q3',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4257.421605,
    mittl_preis_qm_kauf_neubau: 6469.355664,
    mittl_preis_qm_miete_bestand: 9.146767935,
    mittl_preis_qm_miete_neubau: 17.32428566,
    _angebote_kauf_bestand: 556,
    _angebote_kauf_neubau: 30,
    _angebote_miete_bestand: 362,
    _angebote_miete_neubau: 63,
    zeit: '2020-Q3',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4276.333811,
    mittl_preis_qm_kauf_neubau: 6230.538205,
    mittl_preis_qm_miete_bestand: 10.19639392,
    mittl_preis_qm_miete_neubau: 16.91424653,
    _angebote_kauf_bestand: 544,
    _angebote_kauf_neubau: 39,
    _angebote_miete_bestand: 330,
    _angebote_miete_neubau: 73,
    zeit: '2020-Q2',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4145.53333,
    mittl_preis_qm_kauf_neubau: 5671.895145,
    mittl_preis_qm_miete_bestand: 10.23627082,
    mittl_preis_qm_miete_neubau: 15.83324324,
    _angebote_kauf_bestand: 561,
    _angebote_kauf_neubau: 35,
    _angebote_miete_bestand: 480,
    _angebote_miete_neubau: 74,
    zeit: '2020-Q1',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4209.665321,
    mittl_preis_qm_kauf_neubau: 6521.999301,
    mittl_preis_qm_miete_bestand: 10.12523971,
    mittl_preis_qm_miete_neubau: 18.38916661,
    _angebote_kauf_bestand: 509,
    _angebote_kauf_neubau: 44,
    _angebote_miete_bestand: 292,
    _angebote_miete_neubau: 48,
    zeit: '2020-Q4',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4453.091368,
    mittl_preis_qm_kauf_neubau: 6330.535021,
    mittl_preis_qm_miete_bestand: 9.257525412,
    mittl_preis_qm_miete_neubau: 17.89999995,
    _angebote_kauf_bestand: 454,
    _angebote_kauf_neubau: 54,
    _angebote_miete_bestand: 295,
    _angebote_miete_neubau: 40,
    zeit: '2021-Q1',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4640.360228,
    mittl_preis_qm_kauf_neubau: 6675.355748,
    mittl_preis_qm_miete_bestand: 10.52271136,
    mittl_preis_qm_miete_neubau: 17.85749993,
    _angebote_kauf_bestand: 479,
    _angebote_kauf_neubau: 35,
    _angebote_miete_bestand: 343,
    _angebote_miete_neubau: 40,
    zeit: '2021-Q2',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4747.214973,
    mittl_preis_qm_kauf_neubau: 7192.129539,
    mittl_preis_qm_miete_bestand: 10.54867283,
    mittl_preis_qm_miete_neubau: 16.95565224,
    _angebote_kauf_bestand: 392,
    _angebote_kauf_neubau: 44,
    _angebote_miete_bestand: 324,
    _angebote_miete_neubau: 46,
    zeit: '2021-Q3',
  },
  {
    name: 'Neukölln',
    mittl_preis_qm_kauf_bestand: 4809.311448,
    mittl_preis_qm_kauf_neubau: 7373.161799,
    mittl_preis_qm_miete_bestand: 10.25569537,
    mittl_preis_qm_miete_neubau: 16.50038462,
    _angebote_kauf_bestand: 378,
    _angebote_kauf_neubau: 33,
    _angebote_miete_bestand: 302,
    _angebote_miete_neubau: 52,
    zeit: '2021-Q4',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5556.749101,
    mittl_preis_qm_kauf_neubau: 6934.620138,
    mittl_preis_qm_miete_bestand: 12.44941177,
    mittl_preis_qm_miete_neubau: 18.92875713,
    _angebote_kauf_bestand: 841,
    _angebote_kauf_neubau: 335,
    _angebote_miete_bestand: 527,
    _angebote_miete_neubau: 177,
    zeit: '2021-Q2',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5020.139493,
    mittl_preis_qm_kauf_neubau: 5679.90989,
    mittl_preis_qm_miete_bestand: 11.07786327,
    mittl_preis_qm_miete_neubau: 16.31707144,
    _angebote_kauf_bestand: 986,
    _angebote_kauf_neubau: 682,
    _angebote_miete_bestand: 702,
    _angebote_miete_neubau: 140,
    zeit: '2020-Q2',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5413.141248,
    mittl_preis_qm_kauf_neubau: 6292.492601,
    mittl_preis_qm_miete_bestand: 11.62192308,
    mittl_preis_qm_miete_neubau: 18.17470592,
    _angebote_kauf_bestand: 911,
    _angebote_kauf_neubau: 449,
    _angebote_miete_bestand: 520,
    _angebote_miete_neubau: 153,
    zeit: '2021-Q1',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5261.030747,
    mittl_preis_qm_kauf_neubau: 6171.728709,
    mittl_preis_qm_miete_bestand: 11.42775629,
    mittl_preis_qm_miete_neubau: 16.65139538,
    _angebote_kauf_bestand: 1029,
    _angebote_kauf_neubau: 469,
    _angebote_miete_bestand: 517,
    _angebote_miete_neubau: 172,
    zeit: '2020-Q4',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5818.357452,
    mittl_preis_qm_kauf_neubau: 7411.229639,
    mittl_preis_qm_miete_bestand: 12.09405608,
    mittl_preis_qm_miete_neubau: 18.00372268,
    _angebote_kauf_bestand: 764,
    _angebote_kauf_neubau: 229,
    _angebote_miete_bestand: 535,
    _angebote_miete_neubau: 137,
    zeit: '2021-Q4',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5629.732913,
    mittl_preis_qm_kauf_neubau: 7326.289646,
    mittl_preis_qm_miete_bestand: 12.20346414,
    mittl_preis_qm_miete_neubau: 18.0170968,
    _angebote_kauf_bestand: 798,
    _angebote_kauf_neubau: 297,
    _angebote_miete_bestand: 586,
    _angebote_miete_neubau: 155,
    zeit: '2021-Q3',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 5141.340838,
    mittl_preis_qm_kauf_neubau: 5896.733546,
    mittl_preis_qm_miete_bestand: 10.81564841,
    mittl_preis_qm_miete_neubau: 16.4081208,
    _angebote_kauf_bestand: 1038,
    _angebote_kauf_neubau: 611,
    _angebote_miete_bestand: 694,
    _angebote_miete_neubau: 149,
    zeit: '2020-Q3',
  },
  {
    name: 'Pankow',
    mittl_preis_qm_kauf_bestand: 4902.610983,
    mittl_preis_qm_kauf_neubau: 5403.640867,
    mittl_preis_qm_miete_bestand: 11.3528271,
    mittl_preis_qm_miete_neubau: 15.56375694,
    _angebote_kauf_bestand: 977,
    _angebote_kauf_neubau: 677,
    _angebote_miete_bestand: 856,
    _angebote_miete_neubau: 181,
    zeit: '2020-Q1',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3509.214956,
    mittl_preis_qm_kauf_neubau: 5194.986452,
    mittl_preis_qm_miete_bestand: 9.493636353,
    mittl_preis_qm_miete_neubau: 13.15599995,
    _angebote_kauf_bestand: 349,
    _angebote_kauf_neubau: 81,
    _angebote_miete_bestand: 440,
    _angebote_miete_neubau: 20,
    zeit: '2020-Q1',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3658.754662,
    mittl_preis_qm_kauf_neubau: 5653.341183,
    mittl_preis_qm_miete_bestand: 9.261401263,
    mittl_preis_qm_miete_neubau: 13.40936174,
    _angebote_kauf_bestand: 345,
    _angebote_kauf_neubau: 78,
    _angebote_miete_bestand: 314,
    _angebote_miete_neubau: 47,
    zeit: '2020-Q4',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3826.119886,
    mittl_preis_qm_kauf_neubau: 6108.221319,
    mittl_preis_qm_miete_bestand: 9.322916643,
    mittl_preis_qm_miete_neubau: 12.64073177,
    _angebote_kauf_bestand: 352,
    _angebote_kauf_neubau: 92,
    _angebote_miete_bestand: 264,
    _angebote_miete_neubau: 41,
    zeit: '2021-Q1',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3947.334467,
    mittl_preis_qm_kauf_neubau: 6330.795502,
    mittl_preis_qm_miete_bestand: 9.90961414,
    mittl_preis_qm_miete_neubau: 15.64625003,
    _angebote_kauf_bestand: 306,
    _angebote_kauf_neubau: 69,
    _angebote_miete_bestand: 311,
    _angebote_miete_neubau: 48,
    zeit: '2021-Q2',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3578.642702,
    mittl_preis_qm_kauf_neubau: 5685.165324,
    mittl_preis_qm_miete_bestand: 9.090377344,
    mittl_preis_qm_miete_neubau: 13.54633338,
    _angebote_kauf_bestand: 373,
    _angebote_kauf_neubau: 113,
    _angebote_miete_bestand: 371,
    _angebote_miete_neubau: 30,
    zeit: '2020-Q3',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3954.36559,
    mittl_preis_qm_kauf_neubau: 7275.684758,
    mittl_preis_qm_miete_bestand: 9.896748451,
    mittl_preis_qm_miete_neubau: 16.41255318,
    _angebote_kauf_bestand: 286,
    _angebote_kauf_neubau: 52,
    _angebote_miete_bestand: 326,
    _angebote_miete_neubau: 47,
    zeit: '2021-Q3',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 3579.288921,
    mittl_preis_qm_kauf_neubau: 5460.484532,
    mittl_preis_qm_miete_bestand: 9.379300287,
    mittl_preis_qm_miete_neubau: 13.20500006,
    _angebote_kauf_bestand: 345,
    _angebote_kauf_neubau: 84,
    _angebote_miete_bestand: 343,
    _angebote_miete_neubau: 14,
    zeit: '2020-Q2',
  },
  {
    name: 'Reinickendorf',
    mittl_preis_qm_kauf_bestand: 4113.04409,
    mittl_preis_qm_kauf_neubau: 7386.981189,
    mittl_preis_qm_miete_bestand: 9.775449721,
    mittl_preis_qm_miete_neubau: 15.33520834,
    _angebote_kauf_bestand: 315,
    _angebote_kauf_neubau: 40,
    _angebote_miete_bestand: 378,
    _angebote_miete_neubau: 48,
    zeit: '2021-Q4',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3789.539402,
    mittl_preis_qm_kauf_neubau: 6533.719504,
    mittl_preis_qm_miete_bestand: 8.216636561,
    mittl_preis_qm_miete_neubau: 12.72479996,
    _angebote_kauf_bestand: 221,
    _angebote_kauf_neubau: 46,
    _angebote_miete_bestand: 443,
    _angebote_miete_neubau: 25,
    zeit: '2021-Q3',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3262.561356,
    mittl_preis_qm_kauf_neubau: 5171.156385,
    mittl_preis_qm_miete_bestand: 8.175090911,
    mittl_preis_qm_miete_neubau: 12.72515625,
    _angebote_kauf_bestand: 316,
    _angebote_kauf_neubau: 47,
    _angebote_miete_bestand: 495,
    _angebote_miete_neubau: 64,
    zeit: '2020-Q3',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3219.077572,
    mittl_preis_qm_kauf_neubau: 5114.752399,
    mittl_preis_qm_miete_bestand: 8.266049662,
    mittl_preis_qm_miete_neubau: 11.636875,
    _angebote_kauf_bestand: 256,
    _angebote_kauf_neubau: 46,
    _angebote_miete_bestand: 443,
    _angebote_miete_neubau: 64,
    zeit: '2020-Q2',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3673.358414,
    mittl_preis_qm_kauf_neubau: 6158.179766,
    mittl_preis_qm_miete_bestand: 8.269835151,
    mittl_preis_qm_miete_neubau: 15.65649998,
    _angebote_kauf_bestand: 214,
    _angebote_kauf_neubau: 50,
    _angebote_miete_bestand: 364,
    _angebote_miete_neubau: 40,
    zeit: '2021-Q2',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3146.197349,
    mittl_preis_qm_kauf_neubau: 4725.845488,
    mittl_preis_qm_miete_bestand: 8.780000011,
    mittl_preis_qm_miete_neubau: 13.01750008,
    _angebote_kauf_bestand: 287,
    _angebote_kauf_neubau: 42,
    _angebote_miete_bestand: 526,
    _angebote_miete_neubau: 36,
    zeit: '2020-Q1',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3660.548721,
    mittl_preis_qm_kauf_neubau: 6665.691087,
    mittl_preis_qm_miete_bestand: 8.502258763,
    mittl_preis_qm_miete_neubau: 12.64451623,
    _angebote_kauf_bestand: 222,
    _angebote_kauf_neubau: 52,
    _angebote_miete_bestand: 456,
    _angebote_miete_neubau: 62,
    zeit: '2021-Q4',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3549.008554,
    mittl_preis_qm_kauf_neubau: 5442.44364,
    mittl_preis_qm_miete_bestand: 8.697471239,
    mittl_preis_qm_miete_neubau: 14.85999994,
    _angebote_kauf_bestand: 269,
    _angebote_kauf_neubau: 61,
    _angebote_miete_bestand: 348,
    _angebote_miete_neubau: 73,
    zeit: '2021-Q1',
  },
  {
    name: 'Spandau',
    mittl_preis_qm_kauf_bestand: 3311.246763,
    mittl_preis_qm_kauf_neubau: 5353.40918,
    mittl_preis_qm_miete_bestand: 8.530317065,
    mittl_preis_qm_miete_neubau: 11.55191662,
    _angebote_kauf_bestand: 316,
    _angebote_kauf_neubau: 59,
    _angebote_miete_bestand: 410,
    _angebote_miete_neubau: 120,
    zeit: '2020-Q4',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4692.924155,
    mittl_preis_qm_kauf_neubau: 7071.801409,
    mittl_preis_qm_miete_bestand: 10.69944118,
    mittl_preis_qm_miete_neubau: 16.03033331,
    _angebote_kauf_bestand: 964,
    _angebote_kauf_neubau: 77,
    _angebote_miete_bestand: 340,
    _angebote_miete_neubau: 60,
    zeit: '2020-Q4',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4878.769134,
    mittl_preis_qm_kauf_neubau: 7038.9204,
    mittl_preis_qm_miete_bestand: 11.38148541,
    mittl_preis_qm_miete_neubau: 16.49580008,
    _angebote_kauf_bestand: 833,
    _angebote_kauf_neubau: 46,
    _angebote_miete_bestand: 377,
    _angebote_miete_neubau: 50,
    zeit: '2021-Q2',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4657.111293,
    mittl_preis_qm_kauf_neubau: 7004.540988,
    mittl_preis_qm_miete_bestand: 10.93171366,
    mittl_preis_qm_miete_neubau: 17.43434777,
    _angebote_kauf_bestand: 969,
    _angebote_kauf_neubau: 140,
    _angebote_miete_bestand: 461,
    _angebote_miete_neubau: 46,
    zeit: '2020-Q2',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4912.706443,
    mittl_preis_qm_kauf_neubau: 7108.296176,
    mittl_preis_qm_miete_bestand: 11.8301182,
    mittl_preis_qm_miete_neubau: 17.83374998,
    _angebote_kauf_bestand: 760,
    _angebote_kauf_neubau: 58,
    _angebote_miete_bestand: 423,
    _angebote_miete_neubau: 72,
    zeit: '2021-Q3',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4792.161391,
    mittl_preis_qm_kauf_neubau: 6900.587346,
    mittl_preis_qm_miete_bestand: 10.72534589,
    mittl_preis_qm_miete_neubau: 17.86244443,
    _angebote_kauf_bestand: 850,
    _angebote_kauf_neubau: 61,
    _angebote_miete_bestand: 318,
    _angebote_miete_neubau: 45,
    zeit: '2021-Q1',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4650.641854,
    mittl_preis_qm_kauf_neubau: 7107.019483,
    mittl_preis_qm_miete_bestand: 10.89049999,
    mittl_preis_qm_miete_neubau: 16.25025001,
    _angebote_kauf_bestand: 931,
    _angebote_kauf_neubau: 143,
    _angebote_miete_bestand: 540,
    _angebote_miete_neubau: 40,
    zeit: '2020-Q1',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4670.244834,
    mittl_preis_qm_kauf_neubau: 7150.317619,
    mittl_preis_qm_miete_bestand: 10.68724137,
    mittl_preis_qm_miete_neubau: 16.13793099,
    _angebote_kauf_bestand: 1028,
    _angebote_kauf_neubau: 118,
    _angebote_miete_bestand: 406,
    _angebote_miete_neubau: 58,
    zeit: '2020-Q3',
  },
  {
    name: 'Steglitz-Zehlendorf',
    mittl_preis_qm_kauf_bestand: 4962.846074,
    mittl_preis_qm_kauf_neubau: 7796.273525,
    mittl_preis_qm_miete_bestand: 11.52601563,
    mittl_preis_qm_miete_neubau: 16.91618424,
    _angebote_kauf_bestand: 706,
    _angebote_kauf_neubau: 56,
    _angebote_miete_bestand: 384,
    _angebote_miete_neubau: 76,
    zeit: '2021-Q4',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 5031.557485,
    mittl_preis_qm_kauf_neubau: 6864.326859,
    mittl_preis_qm_miete_bestand: 10.54511002,
    mittl_preis_qm_miete_neubau: 18.75230771,
    _angebote_kauf_bestand: 673,
    _angebote_kauf_neubau: 86,
    _angebote_miete_bestand: 409,
    _angebote_miete_neubau: 52,
    zeit: '2021-Q3',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4869.48145,
    mittl_preis_qm_kauf_neubau: 6831.193982,
    mittl_preis_qm_miete_bestand: 10.26650568,
    mittl_preis_qm_miete_neubau: 19.87476183,
    _angebote_kauf_bestand: 660,
    _angebote_kauf_neubau: 91,
    _angebote_miete_bestand: 352,
    _angebote_miete_neubau: 42,
    zeit: '2021-Q2',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4758.980166,
    mittl_preis_qm_kauf_neubau: 6524.300026,
    mittl_preis_qm_miete_bestand: 9.352937295,
    mittl_preis_qm_miete_neubau: 20.02622208,
    _angebote_kauf_bestand: 789,
    _angebote_kauf_neubau: 97,
    _angebote_miete_bestand: 303,
    _angebote_miete_neubau: 45,
    zeit: '2021-Q1',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4619.090151,
    mittl_preis_qm_kauf_neubau: 6439.45571,
    mittl_preis_qm_miete_bestand: 9.826975469,
    mittl_preis_qm_miete_neubau: 18.4834848,
    _angebote_kauf_bestand: 881,
    _angebote_kauf_neubau: 109,
    _angebote_miete_bestand: 367,
    _angebote_miete_neubau: 66,
    zeit: '2020-Q4',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4479.294894,
    mittl_preis_qm_kauf_neubau: 5438.736588,
    mittl_preis_qm_miete_bestand: 10.16198166,
    mittl_preis_qm_miete_neubau: 15.41829791,
    _angebote_kauf_bestand: 802,
    _angebote_kauf_neubau: 64,
    _angebote_miete_bestand: 545,
    _angebote_miete_neubau: 47,
    zeit: '2020-Q1',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4993.500539,
    mittl_preis_qm_kauf_neubau: 7373.748485,
    mittl_preis_qm_miete_bestand: 10.74439394,
    mittl_preis_qm_miete_neubau: 17.41324319,
    _angebote_kauf_bestand: 616,
    _angebote_kauf_neubau: 78,
    _angebote_miete_bestand: 396,
    _angebote_miete_neubau: 37,
    zeit: '2021-Q4',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4552.991712,
    mittl_preis_qm_kauf_neubau: 6074.810225,
    mittl_preis_qm_miete_bestand: 9.581894985,
    mittl_preis_qm_miete_neubau: 18.45126435,
    _angebote_kauf_bestand: 889,
    _angebote_kauf_neubau: 100,
    _angebote_miete_bestand: 438,
    _angebote_miete_neubau: 87,
    zeit: '2020-Q3',
  },
  {
    name: 'Tempelhof-Schöneberg',
    mittl_preis_qm_kauf_bestand: 4508.341541,
    mittl_preis_qm_kauf_neubau: 5880.586297,
    mittl_preis_qm_miete_bestand: 9.814944438,
    mittl_preis_qm_miete_neubau: 17.6019999,
    _angebote_kauf_bestand: 765,
    _angebote_kauf_neubau: 57,
    _angebote_miete_bestand: 360,
    _angebote_miete_neubau: 60,
    zeit: '2020-Q2',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 4159.109496,
    mittl_preis_qm_kauf_neubau: 6198.126774,
    mittl_preis_qm_miete_bestand: 10.24947473,
    mittl_preis_qm_miete_neubau: 14.65230767,
    _angebote_kauf_bestand: 360,
    _angebote_kauf_neubau: 90,
    _angebote_miete_bestand: 495,
    _angebote_miete_neubau: 195,
    zeit: '2021-Q2',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 3778.750217,
    mittl_preis_qm_kauf_neubau: 5703.612646,
    mittl_preis_qm_miete_bestand: 9.320461816,
    mittl_preis_qm_miete_neubau: 13.32471948,
    _angebote_kauf_bestand: 461,
    _angebote_kauf_neubau: 133,
    _angebote_miete_bestand: 498,
    _angebote_miete_neubau: 303,
    zeit: '2020-Q4',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 4463.033698,
    mittl_preis_qm_kauf_neubau: 6843.095165,
    mittl_preis_qm_miete_bestand: 10.37343435,
    mittl_preis_qm_miete_neubau: 15.52203794,
    _angebote_kauf_bestand: 370,
    _angebote_kauf_neubau: 118,
    _angebote_miete_bestand: 495,
    _angebote_miete_neubau: 211,
    zeit: '2021-Q4',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 4070.257124,
    mittl_preis_qm_kauf_neubau: 6009.984307,
    mittl_preis_qm_miete_bestand: 9.779718862,
    mittl_preis_qm_miete_neubau: 13.78134949,
    _angebote_kauf_bestand: 382,
    _angebote_kauf_neubau: 107,
    _angebote_miete_bestand: 498,
    _angebote_miete_neubau: 289,
    zeit: '2021-Q1',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 3642.331422,
    mittl_preis_qm_kauf_neubau: 5411.129689,
    mittl_preis_qm_miete_bestand: 9.248521109,
    mittl_preis_qm_miete_neubau: 13.63826228,
    _angebote_kauf_bestand: 478,
    _angebote_kauf_neubau: 154,
    _angebote_miete_bestand: 568,
    _angebote_miete_neubau: 305,
    zeit: '2020-Q3',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 4341.984294,
    mittl_preis_qm_kauf_neubau: 6429.307358,
    mittl_preis_qm_miete_bestand: 10.61980544,
    mittl_preis_qm_miete_neubau: 15.32093137,
    _angebote_kauf_bestand: 331,
    _angebote_kauf_neubau: 113,
    _angebote_miete_bestand: 514,
    _angebote_miete_neubau: 204,
    zeit: '2021-Q3',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 3424.769383,
    mittl_preis_qm_kauf_neubau: 5739.153838,
    mittl_preis_qm_miete_bestand: 9.91095809,
    mittl_preis_qm_miete_neubau: 13.34843207,
    _angebote_kauf_bestand: 442,
    _angebote_kauf_neubau: 149,
    _angebote_miete_bestand: 668,
    _angebote_miete_neubau: 287,
    zeit: '2020-Q1',
  },
  {
    name: 'Treptow-Köpenick',
    mittl_preis_qm_kauf_bestand: 3546.345666,
    mittl_preis_qm_kauf_neubau: 5443.701928,
    mittl_preis_qm_miete_bestand: 9.358853966,
    mittl_preis_qm_miete_neubau: 13.82798422,
    _angebote_kauf_bestand: 406,
    _angebote_kauf_neubau: 146,
    _angebote_miete_bestand: 541,
    _angebote_miete_neubau: 253,
    zeit: '2020-Q2',
  },
]
